import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monthly',
  templateUrl: './monthly.component.html',
  styleUrls: ['./monthly.component.scss']
})
export class MonthlyComponent implements OnInit {
  // public items = [
  //   { name: 'Swarm', price: 1, desc: '*PER TRANSACTION', setUpFee: '99', isFree: true },
  //   // { name: 'Housecall Pro', price: 299, desc: '*MAX 9 USERS', setUpFee: '0' },
  //   { name: 'Service Fusion', price: 489, desc: '*PER USER', setUpFee: '500' },
  //   { name: 'Field Edge', price: 150, desc: '*PER USER', setUpFee: '1000-4000' },
  //   { name: 'Service Titan', price: 245, desc: '*PER USER', setUpFee: '800' }
  // ]

  public items = [
    { 
      name: 'Starter', 
      subtitle: 'Perfect for solo operators or small teams',
      price: 99, 
      desc: '+ 1% PER TRANSACTION', 
      setUpFee: '0', 
      standout: false, 
      features: [
        { title: "Core Modules Unlocked", available: true },
        { title: "AI Operations", available: true },
        { title: "AI Calling", available: true },
        { title: "AI Dispatcher", available: true },
        { title: "AI Scheduling", available: true },
        { title: "AI Inventory Management", available: false },
        { title: "* Standard Leads", available: false },
        { title: "Advanced Reporting", available: false },
        { title: "200 Monthly AI Calling Minutes", available: false }
      ]
    },
    { 
      name: 'Growth', 
      subtitle: 'Scale ops + get leads flowing', 
      price: 199, 
      desc: '+ 1% PER TRANSACTION', 
      setUpFee: '0', 
      standout: true,  
      features: [
        { title: "Core Modules Unlocked", available: true },
        { title: "AI Operations", available: true },
        { title: "AI Calling", available: true },
        { title: "AI Dispatcher", available: true },
        { title: "AI Scheduling", available: true },
        { title: "AI Inventory Management", available: true },
        { title: "* Standard Leads", available: true },
        { title: "Advanced Reporting", available: false },
        { title: "200 Monthly AI Calling Minutes", available: false }
      ]
    },
    { 
      name: 'Pro', 
      subtitle: 'Maximize growth with AI + lead dominance', 
      price: 299, 
      desc: '+ 1% PER TRANSACTION', 
      setUpFee: '0', 
      standout: false, 
      features: [
        { title: "Core Modules Unlocked", available: true },
        { title: "AI Operations", available: true },
        { title: "AI Calling", available: true },
        { title: "AI Dispatcher", available: true },
        { title: "AI Scheduling", available: true },
        { title: "AI Inventory Management", available: true },
        { title: "* Priority Leads", available: true },
        { title: "Advanced Reporting", available: true },
        { title: "200 Monthly AI Calling Minutes", available: true }
      ] 
    },
  ]

  constructor() { }

  ngOnInit() {
  }

}
